import { render } from "./ConsultaPrint.vue?vue&type=template&id=78529680&scoped=true"
import script from "./ConsultaPrint.vue?vue&type=script&lang=js"
export * from "./ConsultaPrint.vue?vue&type=script&lang=js"

import "./ConsultaPrint.vue?vue&type=style&index=0&id=78529680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78529680"]])

export default __exports__